<template>
    <div class="vx-row">
        <vs-card>
            <!-- <div slot="header">
                <h5>Historique des requêts par clients et par période</h5>
            </div> -->
            <vs-row>
                <vs-col>
                    <div class="flex -mx-2">
                        <!--
                        <div class="w-1/4 px-2">
                            <span>Liste des clients</span>
                            <v-select v-model="customer" class="w-full" label="social_reason"
                                placeholder="Sélectionner un client"
                                :reduce="user => user.id"
                                :options="customers">
                            </v-select>
                        </div>
                        -->
                        <div class="w-1/4 px-2">
                            <span class="vs-select--label">Période</span>
                            <date-range-picker
                                ref="picker"
                                :opens="opens"
                                :locale-data=locale
                                :singleDatePicker="false"
                                :timePicker=false
                                :showWeekNumbers="showWeekNumbers"
                                :showDropdowns="showDropdowns"
                                :autoApply="autoApply"
                                v-model="dateRange"
                                :ranges=false
                                @update="updateValues"
                                :linkedCalendars="linkedCalendars"
                                :dateFormat="dateFormat"
                                :always-show-calendars="false"
                                :alwaysShowCalendars="alwaysShowCalendars"
                                class="vs-inputx vs-input--input"
                            >
                                <div slot="input" slot-scope="picker" style="min-width: 350px;">
                                {{ picker.startDate | date }} - {{ picker.endDate | date }}
                                </div>
                            </date-range-picker>
                        </div>
                        <div class="w-1/8 px-2">
                            <vs-button :disabled="dateRange.startDate === '' && dateRange.endDate === ''" @click="makeSearch()" style="margin-top: 18px;" color="primary"
                                        type="filled" icon="search">Rechercher
                            </vs-button>
                        </div>
                    </div>
                </vs-col>
            </vs-row>
            <vs-divider></vs-divider>
            <div>
                <vs-table :data="customers">
                    <div style="margin-top:20px;margin-bottom:20px;margin-right:20px" slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                        <h5>Top 1O des entreprises ayant envoyé une demande sur une période</h5>
                    </div>

                    <template slot="thead">
                        <vs-th width="30%">Nom de l'entreprise</vs-th>
                        <vs-th width="20%">Nombre de requêtes</vs-th>
                        <vs-th>Action</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                            <vs-td>{{tr.name}}</vs-td>
                            <vs-td>{{tr.nbr}}</vs-td>
                            <vs-td>
                                <vs-button color="primary" @click="exportStats(tr)" size="small" type="border">Exporter les détails</vs-button>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </vs-card>
    </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from "moment";
export default {
    components: {DateRangePicker},
    data: () => ({
        totalRequest: 0,
        totalInProgress: 0,
        totalTreat: 0,
        totalAt: 0,
        customers: [],
        user: 0,
        customer: '',
        stats: [],
        requests: [],
        last_page: null,
        page: 1,
        opens: 'right',
        showWeekNumbers: true,
        linkedCalendars: true,
        alwaysShowCalendars: true,
        showDropdowns: true,
        autoApply: false,
        locale: {
            direction: 'ltr',
            format: 'dd/mm/yyyy',
            separator: ' - ',
            applyLabel: 'Appliquer',
            cancelLabel: 'Annuler',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 0
        },
        dateRange: {
            startDate: "",
            endDate: "",
        },

    }),
    mounted(){
        this.dateRange.startDate = moment(new Date()).format('YYYY-MM-DD')
        this.dateRange.endDate = moment(new Date()).format('YYYY-MM-DD')
        //this.getCustomers()
        this.makeSearch()
    },
    methods:{
        dateFormat(classes, date) {
            let yesterday = moment().subtract(1, 'day');
            if (!classes.disabled) {
            }
            return classes
        },
        async getCustomers() {
          this.$vs.loading()
          let response = await this.$store.state.customers({})
            .catch((error) => {
              console.log('error: ', error)
            });
          this.customers = response.data;
          this.$vs.loading.close()
        },
        updateValues(values) {
            this.dateRange.startDate = moment(values.startDate).format('YYYY-MM-DD');
            this.dateRange.endDate = moment(values.endDate).format('YYYY-MM-DD');
        },
        makeSearch(){
            this.$vs.loading()
            this.$http.post('/ebu/history-request-search', {
                date_debut: this.dateRange.startDate,
                date_fin: this.dateRange.endDate,
            }).then((response) =>{
                this.$vs.loading.close()
                this.customers = response.data
            }).catch((error) => {
                this.$vs.loading.close()
                console.log(error)
            })
        },
        async exportStats(row) {
            this.$vs.loading()
            this.$http.post('/ebu/history-request-export', {
                date_debut: this.dateRange.startDate,
                date_fin: this.dateRange.endDate,
                customer: row.customer_id
            }, {
                responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                //link.href = response.data.file
                link.href = link.href = url
                link.setAttribute('download', 'details_top_10_' + row.name + '.xlsx')
                document.body.appendChild(link)
                link.click()
                this.customer = ''
                this.$vs.loading.close()
            }).catch((error) => {
                this.$vs.loading.close()
                if (error.response.status === 401) {
                this.$vs.notify({
                    title: 'Erreur',
                    text: 'Votre session a expiré',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    position: 'top-right'
                })
                this.$router.push({name: "login"})
                }
            })
        }
    }
}
</script>
